import { formatEther, hexToBigInt } from 'viem'

import { formatTicks } from './string.helpers'

const formatToDecimals = (n, m) => n.toFixed(m)

const formatCurrencyValue = (value, maxDigits = 3) => {
  return value ? parseFloat(formatToDecimals(parseFloat(value), maxDigits)) : 0
}

const roundDownDecimals = (n, m) => {
  const factor = Math.pow(10, m)
  return Math.floor(n * factor) / factor
}

const numberCeil = (number) => Math.ceil(number)

const floorNumber = (n) => Math.floor(n)

const formatCurrencyShort = (value, maxDigits = 2) => {
  return formatTicks(formatCurrencyValue(value, maxDigits))
}

const percentageOfCompletion = (current, total) => {
  if (!total) {
    return 0
  }
  const completed = (current / total) * 100
  return Math.round(completed > 100 ? 100 : completed)
}

const formatAmount = (value) => {
  return value ? formatEther(value) : 0
}

const formatSCAmount = (value, prefix = '') => {
  return formatEther(hexToBigInt(`${prefix}${value}`))
}

const formatCurrency = (value) => {
  return formatTicks(value)
}

const formatToKM = (num) => {
  num = parseFloat(num)
  if (num < 1000) {
    return formatCurrencyValue(num, 2)
  } else if (num < 1_000_000) {
    return (num / 1000).toFixed(2).replace(/\.?0+$/, '') + 'k'
  } else {
    return (num / 1_000_000).toFixed(2).replace(/\.?0+$/, '') + 'M'
  }
}

export {
  formatToDecimals,
  formatCurrencyValue,
  roundDownDecimals,
  numberCeil,
  floorNumber,
  formatCurrencyShort,
  percentageOfCompletion,
  formatAmount,
  formatCurrency,
  formatSCAmount,
  formatToKM
}
